import React, { createContext, ReactNode, useContext, useState } from 'react';

interface HeaderContextType {
  title: ReactNode;
  setTitle: (title: ReactNode) => void;
}

const HeaderContext = createContext<HeaderContextType | undefined>(undefined);

interface HeaderProviderProps {
  children: ReactNode;
}

export const HeaderProvider: React.FC<HeaderProviderProps> = ({ children }) => {
  const [title, setTitle] = useState<ReactNode>('Dashboard');

  return <HeaderContext.Provider value={{ title, setTitle }}>{children}</HeaderContext.Provider>;
};

export const useHeader = (): HeaderContextType => {
  const context = useContext(HeaderContext);
  if (context === undefined) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }
  return context;
};
